module.exports = __webpack_public_path__ + "static/media/ng05.55502dac.webp";